// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, PropsWithChildren } from "react";
import { css } from "styled-components";

export interface CardContainerStyles {
    cardDivider?: InjectableCss;
    gridItem?: GridItemProps;
}

export const cardContainerStyles: CardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            page-break-inside: avoid;
        `,
    },
    gridItem: {
        width: 12,
    },
};

const CardContainer: FC<
    PropsWithChildren<{
        extendedStyles?: CardContainerStyles;
    }>
> = ({ extendedStyles, children }) => {
    const [styles] = React.useState(() => mergeToNew(cardContainerStyles, extendedStyles));

    return (
        <GridItem {...styles.gridItem}>
            <StyledWrapper {...styles.cardDivider} className="card_container__wrapper">
                {children}
            </StyledWrapper>
        </GridItem>
    );
};

export default CardContainer;
